.portfolioRotationWrapper {
  display: flex;
  flex-flow: row nowrap;
  pointer-events: none;
}

/*
  the outer portfolioWrapper is styled by our parent, so e.g. it can be rotated around the table
  however, we want to align each neighborhood to each other within that transform, so we have an inner wrapper
*/
.portfolioInnerWrapper {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  pointer-events: auto;
  justify-content: center;
}

.neighborhoodWrapper {
  position: relative;
  width: 70px;
}

.neighborhood-darkBlue {
}

.cashPileWrapper {
  position: relative;
}

.cardImage {
  position: absolute;

  &:hover {
    z-index: 1;
  }

  &.clickable {
    cursor: pointer;
  }

  &.clickable.selected {
    z-index: 2;
    border: 2px solid aqua;
  }
}

.portfolioInnerWrapper {
  position: relative;
}

.playerIdentificationAndBadges {
  position: absolute;
  z-index: 1;
  right: calc(100% + 25px);
  top: 50%;
  transform: translateY(calc(-50% - 12px));
}

.gravatarTooltipWrapper {
  position: relative;

  & .handCount {
    position: absolute;
    top: calc(100% + 4px);
    text-align: center;
    white-space: nowrap;
    width: max-content;
    left: 50%;
    transform: translateX(-50%);
    line-height: 12px;
  }
}

.gravatarTooltipWrapper:hover img {
  filter: drop-shadow(0px 2px 6px rgba(255, 255, 255, 0.3));
}

.gravatarTooltipBubble {
  border-radius: 4px;
  left: 45%;
  bottom: calc(100% + 4px);
}

.gravatarTooltipText {
  /* safari needed this here instead of in .x-tooltip-bubble to prevent text wrapping for some reason
    maybe safari doesn't use the padding width to calculate `width: max-content`?
  */
  padding: 2px 12px;
}
